// @ts-nocheck

import { useState } from "react";

// react-router-dom components
import { Link, useNavigate } from "react-router-dom";

// @mui material components
import Switch from "@mui/material/Switch";

// Soft UI Dashboard React components
import SoftBox from "../../../components/common/softBox";
import SoftTypography from "../../../components/common/softTypography";
import SoftInput from "../../../components/common/softInput";
import SoftButton from "../../../components/common/softButton";

// Authentication layout components
import CoverLayout from "../components/CoverLayout";

// Images
import { useDispatch } from "react-redux";
import { login } from "../../../features/auth";
import { toast } from "react-toastify";

function SignIn() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [rememberMe, setRememberMe] = useState(true);
  const [formData, setFormData] = useState({
    email: "",
    password: ""
  })
  const handleSetRememberMe = () => setRememberMe(!rememberMe);

  const handleChange = (e: any) => {
    const { name, value } = e.target;

    setFormData((prev) => ({ ...prev, [name]: value }))

  }
  const handleSubmit = () => {
    console.log(formData, 'formData');

    dispatch(login(formData)).then((res) => {
      const notify = () => toast.success(res.payload.message);

      notify();
      navigate('/dashboard')
      console.log(res.payload.data.token, "response");
      localStorage.setItem('token', res.payload.data.token)
    }).catch((err) => {
      console.log(err, "error");

    })
  }

  return (
    <CoverLayout
      color="final"
      title="Welcome Back"
      description="Enter your email and password to sign in"
    >
      {/* @ts-ignore  */}

      <SoftBox component="form" role="form">
        {/* @ts-ignore  */}

        <SoftBox  mb={1}>
          {/* @ts-ignore  */}
          <SoftBox mb={0.5} ml={0.5}>
            {/* @ts-ignore  */}
            <SoftTypography component="label" fontSize="14px" variant="caption" fontWeight="medium">
              Email
            </SoftTypography>
          </SoftBox>
          {/* @ts-ignore  */}
          <SoftInput type="email" placeholder="Email" onChange={handleChange} name='email' />
        </SoftBox>
        {/* @ts-ignore  */}
        <SoftBox mb={2}>
          {/* @ts-ignore  */}
          <SoftBox mb={0.5} ml={0.5}>
            {/* @ts-ignore  */}
            <SoftTypography component="label" fontSize="14px" variant="caption" fontWeight="medium">
              Password
            </SoftTypography>
          </SoftBox>
          {/* @ts-ignore  */}
          <SoftInput type="password" placeholder="Password" name='password' onChange={handleChange} />
        </SoftBox>
        {/* @ts-ignore  */}
        <SoftBox display="flex" alignItems="center">
          <Switch checked={rememberMe} onChange={handleSetRememberMe} />
          {/* @ts-ignore  */}
          <SoftTypography
            variant="button"
            fontWeight="regular"
            onClick={handleSetRememberMe}
            sx={{ cursor: "pointer", userSelect: "none" }}
          >
            &nbsp;&nbsp;Remember me
          </SoftTypography>
        </SoftBox>
        {/* @ts-ignore  */}
        <SoftBox mt={3} mb={1}>
          {/* @ts-ignore  */}
          <SoftButton variant="gradient" color="final" fullWidth onClick={handleSubmit}>
            sign in
          </SoftButton>
        </SoftBox>
        {/* @ts-ignore  */}
        <SoftBox mt={3} textAlign="center">
          {/* @ts-ignore  */}
          {/* <SoftTypography variant="button" color="text" fontWeight="regular">
            Don&apos;t have an account?{" "}
            <SoftTypography
              component={Link}
              to="/authentication/sign-up"
              variant="button"
              color="final"
              fontWeight="medium"
              textGradient
            >
              Sign up
            </SoftTypography>
          </SoftTypography> */}
        </SoftBox>
      </SoftBox>
    </CoverLayout>
  );

}

export default SignIn;
